import React, { useState, useEffect } from 'react';

function Data() {
    const [data, setData] = useState([]);

    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL + 'nocnoc/store')
            .then(response => response.json())
            .then(data => {
                console.log(data.data);
                setData(data.data)
            });
    }, []);

    return (
        <div>
            <h1>Data from API</h1>
            <ul>
                {data.map(item => (
                    <li key={item.STATUS}>{item.NAME}</li>
                ))}
            </ul>
        </div>
    );
}

export default Data;